/* eslint-disable react/no-unknown-property */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1370.000000, -2210.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1370.000000, 2210.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.2295747,1.32937182 L27.6706282,17.2295879 L1.7704253,17.6706282 L1.32937182,1.77041205 L27.2295747,1.32937182 Z",
  stroke: "#B9B9B9",
  strokeWidth: "2.65874363"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#B9B9B9",
  transform: "translate(14.000000, 7.500000) rotate(-270.000000) translate(-14.000000, -7.500000) ",
  points: "12 21 16 21 16 -6 12 -6"
})))), 'CreditCard', {
  viewBox: '0 0 29 19'
});